import React from 'react';
import {SaveIndicator} from '@/Components/AutoSave';
import {AutoSave} from '@/AutoSave';
import TestForm from './TestForm';
import StickyQuestionGroup from './StickyQuestionGroup';
import Fraction from '@/Components/Fraction';
import Percentage from '@/Components/Percentage';

export default class TestUI extends React.Component {
    componentDidUpdate(prevProps) {
        if (!prevProps.submitErrors && this.props.submitErrors) {
            window.scrollTo(0, 0);
        }
    }

    renderSubmitErrors() {
        if (!this.props.submitErrors) return;

        let errors = this.props.submitErrors.map((error, i) => {
            return <li key={i}><i className="material-icons">error</i> {error}</li>;
        });

        return <div className="submit-errors-container"><ul>{errors}</ul></div>;
    }

    renderTestForm() {
        let submitErrors = this.renderSubmitErrors();

        if (this.props.isPreview) {
            return (
                <div className="content test">
                    <StickyQuestionGroup />
                    {submitErrors}
                    <TestForm {...this.props} />
                </div>
            );
        }

        return (
            <div className="content test">
                <StickyQuestionGroup />
                <SaveIndicator />
                {submitErrors}
                <AutoSave watch={this.props.formValues} onAutoSave={this.props.onAutoSave}>
                    <TestForm {...this.props} />
                </AutoSave>
            </div>
        );
    }

    renderTotalScore() {
        let scoreContainer;
        let scoreClass = 'col-12 col-md-5 offset-md-6 total-score-container';
        let label = <div className="score-label">Total Score:</div>;

        if (this.props.actualPoints === undefined) {
            let status = this.props.isPreview ? 'Preview Only' : 'Waiting for Grade';

            scoreContainer = (
                <div className={scoreClass}>
                    {label}
                    <Fraction
                        status={status}
                        y={this.props.possiblePoints}
                        unit={this.props.possiblePoints === 1 ? 'pt' : 'pts'}
                    />
                </div>
            );
        } else {
            scoreContainer = (
                <div className={scoreClass}>
                    {label}
                    <Percentage x={this.props.actualPoints} y={this.props.possiblePoints} />
                    <Fraction
                        x={this.props.actualPoints}
                        y={this.props.possiblePoints}
                        unit={this.props.possiblePoints === 1 ? 'pt' : 'pts'}
                    />
                </div>
            );
        }

        return <div className="row">{scoreContainer}</div>;
    }

    renderTestResults() {
        return (
            <div className="content">
                {this.renderTotalScore()}
                <div className="test results">
                    <StickyQuestionGroup />
                    <TestForm {...this.props} />
                </div>
            </div>
        );
    }

    render() {
        return this.props.isTestResults ? this.renderTestResults() : this.renderTestForm();
    }
}
